import { connect } from 'react-redux';
import ResetPage from 'src/components/views/Login/ResetPage';
import { IStoreState } from 'src/entity/StateEntity';

const mapStateToProps = ({ userState: { isDomestic } }: IStoreState) => ({
  isDomestic,
});

export default connect(mapStateToProps)(ResetPage);



// WEBPACK FOOTER //
// ./src/containers/ResetPassword.ts